module.exports = __webpack_public_path__ + "img/901379710.77eadd12.png";